import React, { useState } from 'react';
import { Rating, Typography, TextField, Button, Box } from '@mui/material';
import axios from 'axios';

const RatingForm = ({ appointmentId, onClose, onSubmitSuccess }) => {
    const [rating, setRating] = useState(0);
    const [feedback, setFeedback] = useState('');
    const [message, setMessage] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const apptsUrl = (process.env.REACT_APP_SERVER)
        ? `https://salonserver-k8m8.onrender.com/appointments`
        : `http://localhost:3001/appointments`;

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            setSubmitting(true);
            const response = await axios.patch(
                `${apptsUrl}/${appointmentId}/rate`,
                { rating, feedback },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "Authorization": ` ${localStorage.getItem("token")} `,
                    },
                }
            );
            onSubmitSuccess(appointmentId); // notify parent
            console.log(response.data);
            alert('Thank you for rating!');
            setMessage('Rated successfully!');
            // onRated?.(response.data.appointment);
        } catch (err) {
            setMessage('Rating failed.');
            console.error(err);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>

            <Typography component="legend">Rate this service:</Typography>
            <Rating
                name="rating"
                value={rating}
                onChange={(event, newValue) => setRating(newValue)}
                precision={1}
                max={5}
                sx={{ mb: 2 }}
            />
            <TextField
                label="Feedback (optional)"
                multiline
                rows={3}
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                fullWidth
                variant="outlined"
                sx={{ mb: 2 }}
            />
            <Button type="submit" variant="contained" color="primary" disabled={rating === 0}>
                Submit Rating
            </Button>
        </Box>
    );
};

export default RatingForm;
